/** Vercel Web Analytics custom event names (snake_case). */
export const VA_EVENTS = {
  // Conversions
  LEAD_FORM_SUBMISSION: 'lead_form_submission',
  LEAD_FORM_SUBMIT_ATTEMPT: 'lead_form_submit_attempt',
  LEAD_FORM_SUBMIT_ERROR: 'lead_form_submit_error',
  LEAD_FORM_OPEN: 'lead_form_open',

  // Contact
  CONTACT_PHONE: 'contact_phone',
  CONTACT_EMAIL: 'contact_email',
  CONTACT_DIRECTIONS: 'contact_directions',

  // CTAs and nav
  CTA_CLICK: 'cta_click',

  // Engagement
  CAROUSEL_PREV: 'carousel_prev',
  CAROUSEL_NEXT: 'carousel_next',
  CAROUSEL_SCROLL: 'carousel_scroll',
  CAROUSEL_PLAY_TOGGLE: 'carousel_play_toggle',
  PROJECT_SECTION_SELECT: 'project_section_select',
  PROJECT_IMAGE_NAV: 'project_image_nav',
  SCROLL_TO_TOP: 'scroll_to_top',
  COOKIE_CONSENT_ACCEPT: 'cookie_consent_accept',
  COOKIE_CONSENT_DECLINE: 'cookie_consent_decline',
  LEGAL_TOC_CLICK: 'legal_toc_click',
  ERROR_PAGE_RETRY: 'error_page_retry',
} as const;

export type VaEventName = (typeof VA_EVENTS)[keyof typeof VA_EVENTS];

export type HrefType = 'anchor' | 'internal' | 'external' | 'tel' | 'mailto';
